/**
 * Hook that logs screen views with google analytics
 */
import { useEffect } from 'react'
import firebase from '../firebase/firebase'

function useGAViewLogger(
  screen: string,
  screenClass: string,
  options?: firebase.analytics.AnalyticsCallOptions
): void {
  useEffect(() => {
    const analytics = firebase.analytics()
    analytics.logEvent(
      'screen_view',
      {
        firebase_screen: screen,
        firebase_screen_class: screenClass,
      },
      options
    )
  }, [options, screen, screenClass])
}

export default useGAViewLogger
